import { render, staticRenderFns } from "./order-return-issue-tracking.vue?vue&type=template&id=56aa5b24&"
import script from "./order-return-issue-tracking.vue?vue&type=script&lang=js&"
export * from "./order-return-issue-tracking.vue?vue&type=script&lang=js&"
import style0 from "./order-return-issue-tracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports